if($(window).width() < 1100){
$( document ).ready(function() {
  $('.collection-list').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        initialSlide: 3,
        slidesToScroll: 1,
        arrows: false
      }
    },{
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
 });
});
}

$( document ).ready(function() {
$('#shopify-section-template--22050760458560__media_grid_7q89Gi .media-grid').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});
});




$( document ).ready(function() {
    $('#myModal .modal-content').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      },{
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerPadding:'80px',
          dots: true,
        }
      }
    ]
    });
});